export default __webpack_public_path__ + "static/media/our-team-01.7c5348b4.png";